import { api } from '../utils/jsonp.js'
import { MQTT_CONFIG } from '../utils/constants.js'

/**
 * 通知模块
 */
export class Notification {
  constructor(options = {}) {
    this.counts = {
      total: 0,
      comment: 0,
      agree: 0,
      official: 0
    }
    this.isLoading = false
    this.mqttClient = null
    this.userId = 0
    this.token = ''
    this.user = null
    this.onNotification = options.onNotification || (() => {})
    this.element = null
  }

  async fetchNotifyCount() {
    this.isLoading = true

    try {
      const result = await api.getNotifyCount()

      if (result.StatusCode === 1) {
        this.counts = {
          total: result.Body.Count,
          comment: result.Body.CommentCount,
          agree: result.Body.AgreeCount,
          official: result.Body.OfficialNotifyCount
        }
        this.updateUI()
        return true
      }
      return false
    } catch (error) {
      console.error('获取通知数量失败:', error)
      return false
    } finally {
      this.isLoading = false
    }
  }

  async setReadAll() {
    try {
      const result = await api.setReadAll()

      if (result.StatusCode === 1) {
        this.counts = {
          total: 0,
          comment: 0,
          agree: 0,
          official: 0
        }
        this.updateUI()
        return true
      }
      return false
    } catch (error) {
      console.error('标记已读失败:', error)
      return false
    }
  }

  connectMqtt(uid, userToken) {
    this.userId = uid
    this.token = userToken

    const timestamp = Date.now()
    const isHttps = document.location.protocol === 'https:'
    const port = isHttps ? MQTT_CONFIG.portHttps : MQTT_CONFIG.portHttp
    const protocol = isHttps ? 'wss' : 'ws'

    try {
      const wsUrl = `${protocol}://${MQTT_CONFIG.host}:${port}/mqtt`
      this.mqttClient = new WebSocket(wsUrl, ['mqtt'])

      this.mqttClient.onopen = () => {
        console.log('MQTT 连接成功')
      }

      this.mqttClient.onmessage = (event) => {
        this.onMessageArrived(event.data)
      }

      this.mqttClient.onclose = () => {
        console.log('MQTT 连接断开')
        setTimeout(() => {
          if (this.userId && this.token) {
            this.connectMqtt(this.userId, this.token)
          }
        }, 3000)
      }

      this.mqttClient.onerror = (error) => {
        console.error('MQTT 连接错误:', error)
      }
    } catch (error) {
      console.error('MQTT 连接失败:', error)
    }
  }

  onMessageArrived(data) {
    try {
      const msg = typeof data === 'string' ? JSON.parse(data) : data
      const notifyForm = msg.NotifyForm

      if (notifyForm === -1) return

      if (notifyForm === 0) {
        this.counts.comment++
      } else if (notifyForm === 1) {
        this.counts.agree++
      } else if (notifyForm === 2) {
        this.counts.official++
      }

      this.counts.total++
      this.updateUI()

      this.onNotification({
        action: 'newMessage',
        counts: this.counts
      })
    } catch (error) {
      // 忽略解析错误
    }
  }

  disconnectMqtt() {
    if (this.mqttClient) {
      try {
        this.mqttClient.close()
      } catch (e) {
        // 忽略关闭错误
      }
      this.mqttClient = null
    }
  }

  getNotifyUrl() {
    const { official, comment, agree } = this.counts

    if (official > 0) {
      return 'http://i.gamersky.com/message/notify/official'
    } else if (comment > 0) {
      return 'http://i.gamersky.com/message/notify/writeback'
    } else if (agree > 0) {
      return 'http://i.gamersky.com/message/notify/favour'
    }
    return 'http://i.gamersky.com/message/notify/writeback'
  }

  updateUI() {
    if (!this.element) return

    const numEl = this.element.querySelector('.tz .num')
    if (numEl) {
      if (this.counts.total > 0) {
        numEl.textContent = this.counts.total > 999 ? '999+' : this.counts.total
        numEl.style.display = ''
      } else {
        numEl.style.display = 'none'
      }
    }

    const types = ['comment', 'agree', 'official']
    types.forEach((type, index) => {
      const el = this.element.querySelector(`.a${index + 1} .num`)
      if (el) {
        if (this.counts[type] > 0) {
          el.textContent = this.counts[type] > 999 ? '999+' : this.counts[type]
          el.style.display = ''
        } else {
          el.style.display = 'none'
        }
      }
    })
  }

  setUser(user) {
    this.user = user
    if (user) {
      this.fetchNotifyCount()
      if (user.userid && user.token) {
        this.connectMqtt(user.userid, user.token)
      }
    } else {
      this.disconnectMqtt()
      this.counts = { total: 0, comment: 0, agree: 0, official: 0 }
      this.updateUI()
    }
  }

  /**
   * 渲染通知模块 - 返回 <span class="navtt"> 元素
   * 严格按照 Notification.vue 模板
   */
  render(user) {
    this.user = user

    const container = document.createElement('span')
    container.className = 'navtt'
    container.innerHTML = `
      <a class="alik tongzhi" href="${user ? this.getNotifyUrl() : 'javascript:;'}" ${user ? 'target="_blank"' : ''}>
        <i></i>消息
        ${user && this.counts.total > 0 ? `
          <span class="tz">
            <em class="l"></em>
            <span class="num" data-num="${this.counts.total}">${this.counts.total > 999 ? '999+' : this.counts.total}</span>
            <em class="r"></em>
          </span>
        ` : ''}
      </a>
      ${user ? `
        <div class="topbar-tz">
          <div class="topbar-tz-box">
            <div class="tzcon">
              <div class="tzlik">
                <a class="a1" href="http://i.gamersky.com/message/notify/writeback" target="_blank">
                  <i class="l1"></i>
                  <span class="txt">回复我的</span>
                  <span class="num" style="display: none;"></span>
                  <i class="r"></i>
                </a>
                <a class="a2" href="http://i.gamersky.com/message/notify/favour" target="_blank">
                  <i class="l2"></i>
                  <span class="txt">收到的赞</span>
                  <span class="num" style="display: none;"></span>
                  <i class="r"></i>
                </a>
                <a class="a3" href="http://i.gamersky.com/message/notify/official" target="_blank">
                  <i class="l3"></i>
                  <span class="txt">官方通知</span>
                  <span class="num" style="display: none;"></span>
                  <i class="r"></i>
                </a>
              </div>
            </div>
            <hr>
            <div class="tzbot">
              <div class="lik1">
                <a href="http://i.gamersky.com/user/info/notifysetting" target="_blank">通知设置</a>
              </div>
              <div class="lik2">
                <a class="allbtn">全部标为已读</a>
              </div>
            </div>
          </div>
        </div>
      ` : ''}
    `

    this.element = container
    this.bindEvents()

    if (user) {
      this.fetchNotifyCount()
    }

    return container
  }

  bindEvents() {
    if (!this.element) return

    const self = this
    const allBtn = this.element.querySelector('.allbtn')

    if (allBtn) {
      allBtn.addEventListener('click', async () => {
        const success = await self.setReadAll()
        if (success) {
          self.onNotification({ action: 'readAll', success: true })
        }
      })
    }

    const notifyLink = this.element.querySelector('.tongzhi')
    if (notifyLink) {
      notifyLink.addEventListener('click', () => {
        if (!self.user) {
          self.onNotification({ action: 'login' })
        }
      })
    }
  }
}